import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { bookAnalysesActions } from 'features/bookAnalyses';

const useBookAnalyses = () => {
  const dispatch = useDispatch();
  const getBookAnalyses = useCallback(({ offset }) => dispatch(bookAnalysesActions.getBookAnalyses({ offset })), [dispatch]);
  const getBookAnalysis = useCallback(({ id, cable }) => dispatch(bookAnalysesActions.getBookAnalysis({ id, cable })), [dispatch]);
  const clearLocalBookAnalyses = useCallback(() => dispatch(bookAnalysesActions.clearLocalBookAnalyses()), [dispatch]);
  const clearLocalActiveBookAnalysis = useCallback(() => dispatch(bookAnalysesActions.clearLocalActiveBookAnalysis()), [dispatch]);

  return {
    getBookAnalyses,
    getBookAnalysis,
    clearLocalBookAnalyses,
    clearLocalActiveBookAnalysis
  };
};

export default useBookAnalyses;